// Dependency's modules
import angular from 'angular';
// Factories
import AlertFactory from './factories/alert.factory';
import BookingFactory from './factories/booking.factory';
import NotificationFactory from './factories/notification.factory';
import SportsFactory from './factories/sports.factory';
// Filters
import HumanizeFilter from './filters/humanize.filter';
// Services
import APIService from './services/API.service';
import BookingService from './services/Booking.service';
import ClubService from './services/Club.service';
import CONSTService from './services/CONST.service';
import CourtService from './services/Court.service';
import Echo from './services/Echo.service';
import Notifications from './services/Notifications.service';
import Time from './services/Time.service';
import UserService from './services/User.service';
// Components
import PaginationComponent from './components/common/pagination/pagination.component';
import CreateCashMovementModal from './components/cash-movement/cash-movement.create.component';
import BookingChangeDateModal from './components/booking-chage-date/booking-change-date.component';

const moduleName = 'atc-common';
angular.module(moduleName, [])
    .factory('alerts', AlertFactory)
    .factory('BookingFactory', BookingFactory)
    .factory('NotificationFactory', NotificationFactory)
    .factory('Sports', SportsFactory)
    .filter('humanize', HumanizeFilter)
    .service('API', APIService)
    .service('BookingService', BookingService)
    .service('Club', ClubService)
    .service('CONST', CONSTService)
    .service('Court', CourtService)
    .service('Echo', Echo)
    .service('Notifications', Notifications)
    .service('Time', Time)
    .service('User', UserService)
    .component('atcPager', PaginationComponent)
    .service('CreateCashMovementModal', CreateCashMovementModal)
    .service('BookingChangeDateModal', BookingChangeDateModal)
;

export default moduleName;
